import React, { Component } from "react";
import * as actions from "../../actions";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { EkoForm, EkoFormButton, EkoFormSelect } from "../elements/EkoForm";
import { toastr } from "react-redux-toastr";
import EkoModal from "../elements/EkoModal";
import Api from "../../util/Api";

class PaymentRecorderDeviceInfoModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            saving: false,
            formData: this.defaultFormData,
        };
    }

    get defaultFormData() {
        return {
            integration_company: "0",
            device_type: 0,
            cash_bank_id: "0",
            credit_card_bank_id: "0",
            warehouse_id: "0",
            title: "",
            device_key: "",
            secret_key: "",
            merchant_key: "",
            api_username: "",
            api_password: "",
            pavo_target_serial_no: "",
            pavo_target_fingerprint: "",
            pavo_source_fingerprint: "",
            pavo_application_name: "",
            pavo_source_reference: "",
            pavo_app_token: "",
            pavo_api_key: "",
        };
    }

    normalizeFormDataForIntegrationCompany(formData) {
        const integrationCompany = String(formData.integration_company ?? "0");

        if (integrationCompany === "1") {
            return {
                ...formData,
                device_key: "",
                secret_key: "",
                merchant_key: "",
                api_username: "",
                api_password: "",
            };
        }

        return {
            ...formData,
            pavo_target_serial_no: "",
            pavo_target_fingerprint: "",
            pavo_source_fingerprint: "",
            pavo_application_name: "",
            pavo_source_reference: "",
            pavo_app_token: "",
            pavo_api_key: "",
        };
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.defaultValues &&
            this.props.defaultValues !== prevProps.defaultValues
        ) {
            const merged = {
                ...this.defaultFormData,
                ...this.props.defaultValues,
            };

            this.setState({
                formData: this.normalizeFormDataForIntegrationCompany(merged),
            });
        }
    }

    /**
     *
     * @param string field
     * @param string value
     */
    fieldOnChange(field, value) {
        let formData = { ...this.state.formData, [field]: value };

        if (field === "integration_company") {
            formData = this.normalizeFormDataForIntegrationCompany(formData);
        }

        this.setState({ formData });
    }
    fieldOnMount(field, value) {}
    onSave() {
        this.setState({ saving: true });

        Api.post("/company/paymentRecorderDeviceAdd", this.state.formData, (res, err) => {
            if (res.status==='error') {
                toastr.error("Hata", res.message ?? "Beklenmeyen bir hata oluştu!");
                this.setState({ saving: false });
                return;
            }else{
                toastr.success("Başarılı", "Kayıt başarıyla eklendi");
                this.setState({ saving: false });
                this.props.onHide(true);
            }

        });
    }

    /**
     * Cancel button handler
     */
    cancel(){
        this.setState({formData:this.defaultFormData})
        this.props.onHide();
    }

    render() {
        const fieldProps = {
            onChange: this.fieldOnChange.bind(this),
            onMount: this.fieldOnMount.bind(this),
            formData: this.state.formData,
        };
        return (
            <>
                <EkoModal
                    showModal={this.props.showModal}
                    onHide={this.props.onHide}
                    title={this.props.title}
                >
                    <EkoForm>
                        <div className="row">
                            {this.props.formElements(fieldProps)}
                        </div>
                        <Modal.Footer>
                            <div className="row buttonProccess2">
                                <EkoFormButton
                                    label={this.state.formData.id ? "Güncelle" : "Kaydet & Ekle"}
                                    faClass="fa fa-plus"
                                    isLoading={this.state.saving}
                                    onClick={this.onSave.bind(this)}
                                />
                                <EkoFormButton
                                    label="İptal"
                                    className="btn"
                                    onClick={this.cancel.bind(this)}
                                />
                            </div>
                        </Modal.Footer>
                    </EkoForm>
                </EkoModal>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        viewOptions: state.data.viewOptions,
    };
}

export default connect(mapStateToProps, actions)(PaymentRecorderDeviceInfoModal);
